import { Requester } from './Requester';
import { IUser } from '../types';

export const DeleteContactUser = async ({ contactId }: { contactId: string }): Promise<IUser | null> => {
    try {
        const response = await Requester<{ user: IUser } | null>({
            path: `contacts/${contactId}/user`,
            method: 'DELETE'
        });

        return response && 'user' in response ? (response.user as IUser) : null;
    } catch (e) {
        console.error('Delete contact user request failed');
        return Promise.reject(e);
    }
};
